import { Component, OnInit, Input } from '@angular/core';
import { MbIconTextModule, MbIconModule } from '@am/moebius';
import { NgIf, NgClass } from '@angular/common';

@Component({
    selector: 'services',
    templateUrl: './services.component.html',
    styleUrls: ['./services.component.scss'],
    standalone: true,
    imports: [
        NgIf,
        NgClass,
        MbIconTextModule,
        MbIconModule,
    ],
})
export class ServicesComponent implements OnInit {
  @Input() services: any;

  constructor() {}

  ngOnInit() {}
}
